import React from "react";
import * as moment from "moment";
import SlideShowResponsesPopper from "./SlideShowResponsesPopper";
import LazyLoadImage from "components/LazyLoadImage";

const styles = {
  slideShow: {
    marginTop: "10px",
    margin: "5px",
  },
  image: {
    width: "100%",
    background: "#ccc",
    height: "120px",
    objectFit: "cover",
  },
  timeFilter: {
    height: "35px",
  },
  slideShowHeader: {
    display: "flex",
    padding: "6px",
  },
  slideShowFooter: {
    display: "flex",
    padding: "5px",
    flexDirection: "column",
    fontSize: "12px",
    position: "relative",
  },
  publishedContainer: {
    display: "flex",
    flexDirection: "column",
  },
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "5px",
    paddingRight: "5px",
  },
  publishButton: {
    backgroundColor: "transparent",
    cursor: "pointer",
    border: "0",
    height: "24px",
    paddingLeft: "37px",
  },
};

export default ({ slideShow }) => {
  const classes = styles;

  return (
    <div style={classes.slideShow} key={slideShow.id} className="sidebar-post">
      <LazyLoadImage
        alt={`${slideShow?.media}`}
        key={`${slideShow?.media}`}
        style={classes.image}
        image={slideShow?.media}
        imageWrapperClassName="slideshow-stats-img"
      />
      <div
        style={classes.slideShowFooter}
        className="sidebar-post-content p-3 m-1"
      >
        {/* <div style={classes.publishedContainer}> */}
        <h6>{slideShow?.published_at ? "Published" : "Not Published"}</h6>
        <div className="color-light fs-12">
          {slideShow?.published_at
            ? moment(slideShow.published_at).format("DD/MM/YYYY HH:mm")
            : ""}{" "}
        </div>
        {/* </div> */}
        <p>{slideShow?.topic}</p>
        <div>
          <SlideShowResponsesPopper slideShow={slideShow} />
        </div>
      </div>
    </div>
  );
};
